import { PolicyPremiumBreakupDO } from './../../../BaseFramework/shared/models/PolicyPremiumBreakup.model';
import { PolicyCoverageScheduleDO } from './../../../FunctionalModules/PolicyIssuance/models/PolicyCoverageSchedule.model';
import { filter } from 'rxjs/operators';
import { NewBusinessAppSettings } from './../../Newbusiness/newbusiness-configs/newbusiness-app-settings.config';
import { PolicyIO, ProposalIO } from './../../../BaseFramework/shared/models/common.model';
import { RuleEngineService } from './../../../BaseFramework/core/http/ruleengine.service';
import { WorkqueueService } from './../../../BaseFramework/core/http/workqueue.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewEncapsulation, OnDestroy } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorDO } from './../../../BaseFramework/shared/models/error.model';
import { MetadataService } from './../../../BaseFramework/core/http/metadata.service';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { PolicyCoverageDO } from './../../../BaseFramework/shared/models/other/policyCoverageDO'
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';
import { ProposalCoverageInsuredDO } from 'app/BaseFramework/shared/models/proposal/proposalCoverageInsuredDO';
import { ProposalPremiumBreakupDO } from 'app/BaseFramework/shared/models/proposal/proposalPremiumBreakupDO';


interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}


@Component({
  selector: 'app-product-coverages',
  templateUrl: './product-coverages.component.html',
  styleUrls: ['./product-coverages.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProductCoveragesComponent implements OnInit, OnDestroy {

  //@Input() sumInsuredAmt: any = 100000;
  //@Input() addRows: number = 0;
  @Input() title: string
  //@Input() ExtractPlanTypeCd
  //@Input() IgnorePlanTypeCd
  @Input() configData
  @Input() product;

  _currentComponentName = "ProductCoveragesComponent"

  //refreshAdditionalCoveragesToggle = true;
  refreshBasePlanToggle = true;
  basePlanComponentData = {};
  mandatoryCoverageComponentData = [];
  additionalCoveragesComponentData = [];
  fundAllocationComponentData = {};

  insuredList = [];
  coveragesList: any = [];
  coverages = [];
  /*sumInsuredList = [
    {
      lookupKey: 500000,
      lookupValue: 500000
    },
    {
      lookupKey: 3000000,
      lookupValue: 3000000
    },
    {
      lookupKey: 80000000,
      lookupValue: 80000000
    }]*/

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    private workqueueService: WorkqueueService,
    public newBusinessAppSettings: NewBusinessAppSettings,
    public metadataService: MetadataService,) { }

  //Declaraions which might need developer input
  //ProductCoveragesForm: FormGroup
  //BaseProductForm: FormGroup
  //PRODUCTCOVERAGESFORMNAME = "ProductCoveragesForm"
  //BASEPRODUCTFORMNAME = "BaseProductForm"
  lookupsToBind = ['clmEventTypeCd', 'clmCauseOfDeathCd', 'decisionCd', 'paymentMethodCd', 'paymentModeCd', 'paymentFrequencyCd']
  selectorOfThisComponent = 'app-product-coverages'
  parentEvent$
  productData = []
  //item: any;
  payloadForMandatoryCoverages = null;
  payloadForAdditionalCoverages = null;

  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE   
   */

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  //@Input() type: string;
  @Input() transactionState: string;
  //@Input() DOName: string
  @Input() transformType: string
  @Output() changedField = new EventEmitter<any>()
  formDataChangeHandler(fieldKey){
    // let me = this;
    // me.interactService.formFieldChangeSubject(fieldKey);
    this.changedField.emit(fieldKey);
  }
  EmitChangedField(data){
    this.changedField.emit(data);
  }

  public _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value){
      if (this.transformType == 'LIFE')
      this._inputDataForEdit = this.LifeServerToUITransform(value);
      else if (this.transformType == 'HEALTH')
      this._inputDataForEdit = this.HealthServerToUITransform(value);
    } 
  };

  get inputDataForEdit() {
    return this._inputDataForEdit;
  }

  /**UR : need to check below function**/
  @Output() basePlanComponentOutput = new EventEmitter<any>();
  basePlanComponentOutputHandler(data) {
    this.basePlanComponentOutput.emit(data)
  }

  
 /* currencyOptions = {
    prefix: this.appMetadataHandler.baseCurrencyPREFIX,
    thousands: this.appMetadataHandler.THOUSANDS_SEPARATOR,
    decimal: this.appMetadataHandler.DECIMAL_SEPARATOR,
    align: this.appMetadataHandler.currencyAlignment
  }*/

  LifeEmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.LifeUItoServerTransform)
    console.log("product coverages component output", c);
  }

  HealthEmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.HealthUItoServerTransform)
    console.log("product coverages component output", c);
  }

  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      // this.basePlanComponentData = this.getBasePlan(this._inputDataForEdit);
      this.additionalCoveragesComponentData = this.mapAllCoveragesToPayload(this.additionalCoverageList , this.additionalCoveragesComponentData)
      let componentOutput = {
        BasePlan: this.basePlanComponentData,
        MandatoryCoverages: this.mandatoryCoverageComponentData,
        AdditionalCoverages: this.additionalCoveragesComponentData,
        insuredList: this.lookupDataService.lookupCacheMap['insuredCd'] || []
      }
      const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
      if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {
        //let validationResult = this.validateOutput(this.ProductCoveragesForm)
        /**UR : need to check below function**/
        let validationResult = {isInvalid : false};
        if (!validationResult.isInvalid) {
          let allLOB = "MOTOR,TRAVEL,PROPERTY,HEALTH"
          if (allLOB.includes(this.transformType))
          this.HealthEmitComponentOutput(componentOutput)
            // this.LifeEmitComponentOutput(componentOutput)
          else if (this.transformType === 'LIFE')
            this.LifeEmitComponentOutput(componentOutput)
        }
        else {
          this.HealthEmitComponentOutput(validationResult)
        }
      }
      else {
        console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
      }
    })
  }

  getBasePlan(IO){
    let DO = this.commonUtilty.getDOName(IO);
    if(IO && IO[DO] && this.commonUtilty.isArrayIterable(IO[DO]['proposalCoverages'])){
      let basePlan = IO[DO]['proposalCoverages'].filter(item=>(item.planTypeCd=='BASEPLAN'))
      this.basePlanComponentData = basePlan
    }
    return this.basePlanComponentData;
  }


  validateOutput(o: FormGroup): ValidationOutput {
    this.commonUtilty.markAllFieldDirty(o);

    let validationOutput: ValidationOutput = {
      isInvalid: null,
      errorDOs: []
    }
    validationOutput.errorDOs = this.checkInvalidAndEmptyFields(o, this.getCurrentComponentName())

    if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
      validationOutput.isInvalid = true;
    }
    else {
      validationOutput.isInvalid = false;
    }

    return validationOutput
  }

  //Initializations
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  // Front end error list
  //errorList: any = [];
  insuredlistSubject$;
  //basePlanCodeSubject$;
  //basePlanCd: any = null;

  //public basePlanObj: any;

  //dataSubject$
  //configSubject$
  currentDO : string;
  ngOnInit() {
    this.currentDO = this.configData && this.configData.StateToDOMapper ? this.configData.StateToDOMapper[this.transactionState] : 'proposalDO'
    this.updateConfigData();
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.getCurrentComponentName()}></${this.getCurrentComponentName()}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.getCurrentComponentName()} (componentOdynamicutput)='doSomethingOnDataReceived()'></${this.getCurrentComponentName()}>`, consoleStyle)
      console.groupEnd();
    }
    /*if (!!this.ExtractPlanTypeCd == !!this.IgnorePlanTypeCd) {
      throw "You should either set Extract or set Ignore for a Plan Type, Both filled or empty cannot be used in " + this.getCurrentComponentName()
    }*/

     /**UR :This function may required for future use**/
    /*if (this.insuredlistSubject$ != null)
      this.insuredlistSubject$.unsubscribe();

    this.insuredlistSubject$ = this.interactService.addClientSubject$.subscribe(res => {
      console.log("client list in product coverages component", JSON.stringify(res));

      if (res != null) {
        if (res.role == 'PRIMARYINSURED' || res.role == 'INSURED' || res.role == 'Primary Insured' || res.role == 'Insured') {
          let insuredObj = { clientDO: res.clientDO }
          this.insuredList.push(insuredObj);
        }
      }
    })*/

    // if (this._inputDataForEdit) {
    //   if (this.transformType == 'LIFE')
    //     this.LifeServerToUITransform(this._inputDataForEdit)
    //   else if (this.transformType == 'HEALTH')
    //     this.HealthServerToUITransform(this._inputDataForEdit)
    // }

    //this.initializeProductCoveragesForm(this._inputDataForEdit)
    //this.initializeBaseProductForm(this.basePlanObj)

    /*if (this.configSubject$ != null)
      this.configSubject$.unsubscribe();

    this.configSubject$ = this.interactService.productConfigSubject$.subscribe(value => {
      if (value) {
        let productSpecs = value
        this.getCoveragesConfigurations(productSpecs);
        console.log("productSpecs coverages component", JSON.stringify(productSpecs));
        // this.BaseProductForm.get('baseProductPremium').setValue(policyIO[this.currentDO].finalPremiumAmt);
      }
    })*/

    this.subscribeToParentEvent()
    this.fetchProducts();

    //this.updateCoverageInsuredList();

    /*if (this.toggleInsuredListSubject$ != null) this.toggleInsuredListSubject$.unsubscribe();
    this.toggleInsuredListSubject$ = this.interactService.addClientSubject$.subscribe(val => {
      if (val && (val.role == 'Primary Insured' || val.role == 'Insured'))
        this._toggleRefreshAdditionalCoveragesComponent();
    })

    if (this.toggleCoveragesSubject$ != null) this.toggleCoveragesSubject$.unsubscribe();
    this.toggleCoveragesSubject$ = this.interactService.refreshCoveragesSubject$.subscribe(val => {
      if (val)
        this._toggleRefreshAdditionalCoveragesComponent();
    })*/

    if (this.toggleBasePlanSubject$ != null) this.toggleBasePlanSubject$.unsubscribe();
    this.toggleBasePlanSubject$ = this.interactService.refreshBasePlanSubject$.subscribe(val => {
      if (val)
        this._toggleRefreshBasePlanComponent();
    })

    if (this.refreshCoverageSubject$ != null) this.refreshCoverageSubject$.unsubscribe();
    this.refreshCoverageSubject$ = this.interactService.refreshCoverageSubject$.subscribe(val => {
      if (val)
        this._toggleRefreshCoverageComponent();
    })

    /*if (this.dataSubject$ != null)
      this.dataSubject$.unsubscribe();

    this.dataSubject$ = this.interactService.baseProductDataChangeSubject$.subscribe(value => {
      if (value != null) {
        this.BaseProductForm.get('productCd').setValue(value.productType);
        this.BaseProductForm.get('baseProductSumInsured').setValue(value.sumInsuredAmt);
        this.BaseProductForm.get('baseProductTerm').setValue(value.term);
        this.BaseProductForm.get('premiumPayingTerm').setValue(value.term);
        this.fetchCoverages(value.productType);
      }
    })*/

    // Call config APi here and before that get the product id
      console.log("Payload value :",this.inputDataForEdit)
    // this.apiRequestService
  }

  ngOnDestroy() {
    this.metadataService.productBasedConfigData = [];
   }

  /*riderAttributeList = [];
  productRiderAssociationList = [];
  getCoveragesConfigurations(productSpecs) {
    if (productSpecs && productSpecs.length && productSpecs.length > 0) {
      this.productRiderAssociationList = productSpecs[0].productRiderAssociationList;
      this.riderAttributeList = this.productRiderAssociationList.filter(item => item.productRiderAttributelist)
    }
  }*/

  //custom_InsuredLookup = [];
   /**UR :This function may required for future use**/
  /*updateCoverageInsuredList(){
    if(this.inputDataForEdit && this.commonUtilty.isArrayIterable(this.inputDataForEdit.clientDOs)){
        let lookupList = this.inputDataForEdit.clientDOs.map(item => {
          return {lookupKey : item.guid, lookupValue : item.name};
        })
        this.commonUtilty.setLookupListToCache(lookupList, "custom_InsuredLookup");
    }
  }*/

  /**
   * Form Trasactions
   */
  private _mandatoryCoverageObjList = [];
  public get mandatoryCoverageObjList() {
    return this._mandatoryCoverageObjList;
  }
  public set mandatoryCoverageObjList(value) {
    this._mandatoryCoverageObjList = value;
  }
  additionalCoverageObjList = [];
  additionalCoverageList = [];
   updateConfigData(){
     if(this.commonUtilty.isArrayIterable(this.metadataService.productBasedConfigData)){
      // this.mandatoryCoverageObjList = this.metadataService.productBasedConfigData.filter(e=> e.associationTypeCd == 'MANDATORY');
      // this.additionalCoverageObjList = this.metadataService.productBasedConfigData.filter(e=> e.associationTypeCd == 'OPTIONAL');
      // this.configData.ComponentMetaDataConfiguration.BasePlanComponent = this.metadataService.productBasedConfigData.filter(e=> !e.associationTypeCd);
      this.metadataService.productBasedConfigData.forEach((element,index) => {
        if(!element.uiConfigurations) element.uiConfigurations = [];
        if(element.associationTypeCd == 'MANDATORY'){
          let isRiderCdAvailable = element.uiConfigurations ? element.uiConfigurations.find(item => item.fieldKey == 'riderCd'): undefined;
          if(!isRiderCdAvailable){
            let coverageNameHiddenField = this.createUiConfigHiddenField(element);
            element.uiConfigurations.push(coverageNameHiddenField);
          }
          element.uiConfigurations = this.updateUIMappingOfConfigForCoverage(element.uiConfigurations, index, "mandatoryCoverages", "mandatoryCoveragesArray");
          this.mandatoryCoverageObjList.push(element);
          //this.configData.ComponentMetaDataConfiguration.MandatoryCoveragesComponent.gridConfig.parentRowFormMetaData = element.uiConfigurations;
        }else if(element.associationTypeCd == 'OPTIONAL'){
          let isRiderCdAvailable = element.uiConfigurations ? element.uiConfigurations.find(item => item.fieldKey == 'riderCd'): undefined;
          if(!isRiderCdAvailable){
            let coverageNameHiddenField = this.createUiConfigHiddenField(element);
            element.uiConfigurations.push(coverageNameHiddenField);
          }
          element.uiConfigurations = this.updateUIMappingOfConfigForAdditionalCoverage(element.uiConfigurations,index, "additionalCoverages", "additionalCoveragesArray",this._inputDataForEdit,element.productCd);
          this.additionalCoverageObjList.push(element);
          //this.configData.ComponentMetaDataConfiguration.AdditionalCoveragesComponent.gridConfig.parentRowFormMetaData = element.uiConfigurations;
        }else{
          let updateUIConfig = this.updateUIMappingOfConfig(element.uiConfigurations); //Temporary added as backend suppor is not available
          this.configData.ComponentMetaDataConfiguration.BasePlanComponent = updateUIConfig;
          this._toggleRefreshBasePlanComponent();
        }
      });
     }else{
      if(this.inputDataForEdit && this.inputDataForEdit[this.currentDO] && this.inputDataForEdit[this.currentDO]['baseProductCd']){
        this.workqueueService.fetchUIMetadata(this.inputDataForEdit[this.currentDO]['baseProductCd']).subscribe(response => {
          this.metadataService.productBasedConfigData = response || [];
          this.updateConfigData();
        })
      }
     }
     this.additionalCoverageList = this.commonUtilty.deepCopy(this.additionalCoverageObjList)
   }

   createUiConfigHiddenField(element){
    let obj = {};
    obj['fieldKey'] = "riderCd";
    obj['fieldGenericMapping'] = "";
    obj['fieldMapping'] = "riderCd";
    obj['fieldName'] = "Rider";
    obj['fieldType'] = "INPUT";
    obj['objectName'] = "UIFieldConfigurationDO";
    obj['owner'] = "COMPUTED";
    obj['productCd'] = element.productCd;
    obj['defaultValue'] = element.riderCd;
    obj['readOnly'] = true;
    obj['visible'] = false;
    obj['hidden'] = true;
    return obj;
   }

   updateUIMappingOfConfig(uiConfig){
    if(this.commonUtilty.isArrayIterable(uiConfig)){
      uiConfig.forEach(element => {
        if(element.fieldKey == 'productOption'){
          element.fieldKey = 'planCd';
        }
        element['extractElementFromArray'] = true;
        element['fieldGenericMapping'] = "baseDO-"+element.fieldKey;
        element['fieldMapping'] = this.currentDO +"-"+element.fieldKey;
      });
    }
    return uiConfig;
   }

   updateUIMappingOfConfigForCoverage(uiConfig,index, fieldKey, parentFormArray){
    if(this.commonUtilty.isArrayIterable(uiConfig)){
      let coverageList = this.currentDO == 'caseDO' ? 'caseCoverages' : 'proposalCoverages';
      let CoveragesNode = this.configData.CoverageNodeMapper[this.transactionState];
      uiConfig.forEach(element => {
        //element['fieldKey'] = fieldKey;
        element['fieldMapping'] = this.currentDO + "-"+CoveragesNode+"-"+index+"-"+element['fieldKey'];
        element['fieldGenericMapping'] = "baseDO-"+CoveragesNode+"-"+index+"-"+element['fieldKey'];
        element['parentFormArray'] = parentFormArray;
      });
    }
    return uiConfig;
   }

   updateUIMappingOfConfigForAdditionalCoverage(uiConfig, index, fieldKey, parentFormArray, IO, rider){
    let DO = this.commonUtilty.getDOName(IO)
    let CoveragesNode = this.configData.CoverageNodeMapper[this.transactionState];
    if(this.commonUtilty.isArrayIterable(uiConfig) && rider){
      let coverageList = this.currentDO == 'caseDO' ? 'caseCoverages' : 'proposalCoverages';
      uiConfig.forEach(element => {
        if(IO && IO[DO] && IO[DO] && this.commonUtilty.isArrayIterable(IO[DO][CoveragesNode])){
          let foundIndex = IO[DO][CoveragesNode].findIndex(item=>(rider == item.productCd))
          if(foundIndex != -1){
            //element['fieldKey'] = fieldKey;
            element['fieldMapping'] = this.currentDO + "-"+coverageList+"-"+index+"-"+element['fieldKey'];
            element['fieldGenericMapping'] = "baseDO-"+coverageList+"-"+index+"-"+element['fieldKey'];
            element['parentFormArray'] = parentFormArray;
          }
        }
      });
    }
    return uiConfig;
   }

  /*removeAdditionalCoverage(event){
    console.log(event);
    event.stopPropagation();
  }*/
  
  /*initializeBaseProductForm(data?, DOName?) {

    let payload = data || {}
    if (payload)
      // payload.finalPremiumAmt = 16500;

      this.BaseProductForm = this.fb.group({
        productCd: this.validationUtilService.setValidationsForFormControl('productCd', this.BASEPRODUCTFORMNAME, payload['productCd']),
        baseProductSumInsured: this.validationUtilService.setValidationsForFormControl('baseProductSumInsured', this.BASEPRODUCTFORMNAME, payload['sumInsuredAmt']),
        baseProductTerm: this.validationUtilService.setValidationsForFormControl('baseProductTerm', this.BASEPRODUCTFORMNAME, payload['term']),
        baseProductPremium: this.validationUtilService.setValidationsForFormControl('baseProductPremium', this.BASEPRODUCTFORMNAME, payload['totalPremium']),
        // paymentMode: this.validationUtilService.setValidationsForFormControl('paymentMode', this.BASEPRODUCTFORMNAME, payload['paymentMethodCd']),
        paymentMethod: this.validationUtilService.setValidationsForFormControl('paymentMethod', this.BASEPRODUCTFORMNAME, payload['paymentFrequencyCd']),
        premiumPayingTerm: this.validationUtilService.setValidationsForFormControl('premiumPayingTerm', this.BASEPRODUCTFORMNAME)
      });
  }

  initializeProductCoveragesForm(data?, isEdit?, index?) {

    let payload = data || {}
    this.ProductCoveragesForm = this.fb.group({
      id: payload['id'],
      coverage: this.validationUtilService.setValidationsForFormControl('coverage', this.PRODUCTCOVERAGESFORMNAME, payload['productCd']),
      insured: this.validationUtilService.setValidationsForFormControl('insured', this.PRODUCTCOVERAGESFORMNAME, payload['clientId']),
      sumInsuredAmt: this.validationUtilService.setValidationsForFormControl('sumInsuredAmt', this.PRODUCTCOVERAGESFORMNAME, payload['sumInsuredAmt']),
      // term: this.validationUtilService.setValidationsForFormControl('term', this.PRODUCTCOVERAGESFORMNAME, payload['term']),
      premium: this.validationUtilService.setValidationsForFormControl('premium', this.PRODUCTCOVERAGESFORMNAME, payload['totalPremium']),
      isEdit: this.validationUtilService.setValidationsForFormControl('isEdit', this.PRODUCTCOVERAGESFORMNAME, isEdit),
      index: this.validationUtilService.setValidationsForFormControl('index', this.PRODUCTCOVERAGESFORMNAME, index),
    });
  }*/

  /**UR :This function may required for future use**/
  /*pushMandatoryCoveragesInPayload() {
    this.payloadForMandatoryCoverages = new PolicyIO();
    if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd'])) {
      this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd'].forEach(lookup => {
        let mc = new PolicyCoverageDO();
        mc.productCd = lookup.lookupKey;
        mc.planTypeCd = 'RIDER';
        mc.associationTypeCd = 'MANDATORY';        
        this.payloadForMandatoryCoverages[this.currentDO]['proposalCoverages'].push(mc);
      });
    }
  }*/

  /**UR :This function may required for future use**/
  /*getAllInsuredsFromIO(IO) {
    let output = []
    if (IO) {
      let PRIMARYINSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'PRIMARYINSURED');
      let INSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'INSURED');
      if (PRIMARYINSUREDLIST && Array.isArray(PRIMARYINSUREDLIST))
        output.push(...PRIMARYINSUREDLIST);
      if (INSUREDLIST && Array.isArray(INSUREDLIST))
        output.push(...INSUREDLIST)
    }
    return output
  }*/

  /*isRequired(fieldName: any, formName?: any) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.PRODUCTCOVERAGESFORMNAME
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }*/

  // o.controls.eventTime == null || o.controls.retypeEventTime == null)

  public checkInvalidAndEmptyFields(Form: FormGroup, componentName) {
    let invalidFields = [];
    /*if (!Form.valid) {
      for (const i in Form.controls) {

        let controlName = this.commonUtilty.getControlName(Form.controls[i])
        let validationErrorList = this.validationUtilService.getUIErrorList(this.ProductCoveragesForm.get(controlName), this.PRODUCTCOVERAGESFORMNAME)
        if (Form.controls[i].status === 'INVALID') {
          validationErrorList.forEach(validationError => {
            let errorDO = new ErrorDO();
            errorDO.errorMsg = validationError;
            errorDO.fieldName = controlName;
            // errorDO.fieldNameDescription = this.FormFieldNameMap[controlName]
            errorDO.componentName = componentName;
            invalidFields.push(errorDO)
          })
        }
      }
    }*/
    return invalidFields;
  }

 /* rows = [{ id: 1 }];
  addRow1() {
    let objDummy: any = new PolicyCoverageDO();
    this.inputDataForEdit.push(objDummy);
  }*/

  fetchProducts() {
    this.workqueueService.fetchProducts(this.transformType)
      .subscribe(jsonResp => {
        if (jsonResp && jsonResp.length) {
          jsonResp.forEach((criteria: any) => {
            if (criteria && Object.keys(criteria).length) {
              this.productData.push(criteria);
            } else {
              this.productData = [];
            }
            // let searchCriteriaDO = new SearchAPIMetaDataDO();
            // searchCriteriaDO.key = criteria.attributeName;
            // searchCriteriaDO.keyDescription = criteria.description;
            // searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
            // searchCriteriaDO.lookupName = criteria.attr.ibuteLookupCd;
            // searchCriteriaDO.lookup = [];
            // searchCriteriaDO.enable = true;
            // searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
            // this.CRITERIALOOKUP.push(searchCriteriaDO)
          })
        }
        this.generateUIcoverageBenefitTree();
        this.generateUIcoverageBenefitForPanel();
        console.log("product data when fetching from API", JSON.stringify(this.productData));
      })
  }

  /*fetchCoverages(productCd) {
    if (productCd) {
      this.workqueueService.fetchRiders(productCd)
        .subscribe(jsonResp => {
          this.coverages = [];
          console.log("coverages response", JSON.stringify(jsonResp));
          if (jsonResp && jsonResp.length) {
            jsonResp.forEach((criteria: any) => {
              console.log("criteria", JSON.stringify(criteria));
              // this.coverages = [];
              // coverting to local obj, coz response from server is Array within Array
              if (criteria[2] == 'OPTIONAL') {
                let lookupObj = { lookupKey: criteria[1], lookupValue: criteria[0] }
                this.coverages.push(lookupObj);
              }
            })
          }
          console.log("coverages data when fetching from API", JSON.stringify(this.coverages));
        })
    }
  }

  addCoverages() {
    if (this.ProductCoveragesForm.status === 'VALID') {
      let policyCoverageDO = new PolicyCoverageDO();

      if (this.ProductCoveragesForm.value.isEdit) {
        policyCoverageDO = this.coveragesList[this.ProductCoveragesForm.value.index];
        // addressDO = this.addressList[this.uiAddressIndForm.value.index];
      }

      policyCoverageDO.planTypeCd = "RIDER";
      policyCoverageDO.productCd = this.ProductCoveragesForm.value.coverage;
      policyCoverageDO.sumInsuredAmt = this.ProductCoveragesForm.value.sumInsuredAmt;
      // policyCoverageDO.term = this.ProductCoveragesForm.value.term;
      // policyCoverageDO.totalPremium = this.ProductCoveragesForm.value.premium;
      let insured = this.insuredList.find(item => item.clientDO.id == this.ProductCoveragesForm.value.insured)

      let coveragesInsuredDO = new ProposalCoverageInsuredDO();
      coveragesInsuredDO.clientRefGuid = insured.clientDO.guid;

      // let clientId = null;
      // if (this.insuredList.length > 0) {
      //   this.insuredList.forEach(insuredObj => {
      //     if (insuredObj.guid === this.ProductCoveragesForm.value.insured)
      //       clientId = insuredObj.id;
      //   })
      // }

      coveragesInsuredDO.clientId = insured.clientDO.id;
      coveragesInsuredDO.roleCd = "INSURED";

      policyCoverageDO.policyCoverageInsuredList.push(coveragesInsuredDO);

      if (this.ProductCoveragesForm.value.isEdit) {
        this.coveragesList.splice(this.ProductCoveragesForm.value.index, 1, this.commonUtilty.deepCopy(policyCoverageDO))
      } else {
        this.coveragesList.push(this.commonUtilty.deepCopy(policyCoverageDO));
      }

      // this.EmitComponentOutput(this.coveragesList)
      //this.initializeProductCoveragesForm()
    }
  }

  editCoverage(coverage, index) {
    let isEdit = true;
    //this.initializeProductCoveragesForm(coverage, isEdit, index)
  }

  removeCoverage(coverage, index) {
    this.coveragesList.splice(index, 1);
  }


  getCoverageName(id) {
    let value = ""
    // if (lookupType === "GenderLookup") {
    this.coverages.forEach(covObj => {
      if (covObj.lookupKey === id) {
        value = covObj.lookupValue;
      }
    })

    // if (this.insuredDO.isPrimaryInsured) {
    //     value = "Self";
    // }
    return value;
  }*/

  // onChanges(): void {
  //   this.BaseProductForm.valueChanges.subscribe(val => {
  //     console.log("base product form change value", val);
  //     this.interactService.sendLatestProductData(val);
  //   });
  // }

  /*clearForm() {
    this.ProductCoveragesForm.reset();
  }*/

  // basePlanComponentHandler(data) {
  //   this.BasePlanComponentEmitter.emit(data);
  //   console.log("base plan component data", JSON.stringify(data));
  //   console.log("base plan component ngmodel data", JSON.stringify(this.basePlanComponentData));
  // }

  // mandatoryCoverageComponentHandler(data) {
  //   this.MandatoryCoverageComponentEmitter.emit(data);
  //   console.log("mandatory coverages component data", JSON.stringify(data));
  //   console.log("mandatory coverages component ngmodel data", JSON.stringify(this.mandatoryCoverageComponentData));
  // }

  // additionalCoverageComponentHandler(data) {
  //   this.AdditionalCoverageComponentEmitter.emit(data);
  //   console.log("additional coverages component data", JSON.stringify(data));
  //   console.log("additional coverages component ngmodel data", JSON.stringify(this.additionalCoveragesComponentData));
  // }

  LifeUItoServerTransform(payload, response) {
    let DO = this.commonUtilty.getDOName(payload)
    let CoveragesNode =  DO == 'caseDO' ? 'caseCoverages' : 'proposalCoverages'; 
    let CoveragesInsuredNode = 'proposalCoverageInsureds';
    let clientGuid = null;
    let clientId = null;
    let basePlan = [];
    let mandatoryCoverages = [];
    let additionalCoverages = [];
    if (payload && payload[DO]) {
      if(!response.componentData.BasePlan['BasePlanComponent']){
        response.componentData.BasePlan['BasePlanComponent'] = {};
      }
      response.componentData.BasePlan.BasePlanComponent['policyTerm'] = response.componentData.BasePlan.BasePlanComponent['policyTerm'] || payload[DO]['policyTerm'];
      // base plan transform starts
      let policyClient = payload[DO]["proposalClients"].find(item => item.roleCd === 'PRIMARYINSURED')
      clientGuid = policyClient ? policyClient.clientRefGuid : null;
      clientId = policyClient ? policyClient.clientId : null;
      let foundIndex = payload[DO][CoveragesNode].findIndex(item => item.planTypeCd === 'BASEPLAN')
      if (foundIndex == -1) {
        let coverageInsured = new ProposalCoverageInsuredDO();
        // coverageInsured.clientId = clientId;
        coverageInsured.clientRefGuid = clientGuid;
        coverageInsured.roleCd = "PRIMARYINSURED";
        let coverageInsuredList = [coverageInsured];
        let policyTerm,productCd;
        if(response && response.componentData && response.componentData.BasePlan && response.componentData.BasePlan.BasePlanComponent){
          response.componentData.BasePlan.BasePlanComponent['planOptionCd'] = payload[DO]['productPlanOptionCd'];
          response.componentData.BasePlan.BasePlanComponent['packageCd'] = payload[DO]['packageCd'];          
          response.componentData.BasePlan.BasePlanComponent['productCd']=payload[DO]['baseProductCd'];
          response.componentData.BasePlan.BasePlanComponent['planTypeCd']= "BASEPLAN";
          response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode] = this.commonUtilty.deepCopy(coverageInsuredList);
          policyTerm = response.componentData.BasePlan.BasePlanComponent.policyTerm;
          productCd = response.componentData.BasePlan.BasePlanComponent.productCd;
          payload[DO].sumInsuredAmt = response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt'];
        }
        let coverageSchedule = payload[DO][CoveragesNode].find(item => item.planTypeCd === 'BASEPLAN')
        if (coverageSchedule && coverageSchedule['proposalCoverageSchedules'] && policyTerm === coverageSchedule['proposalCoverageSchedules'].length) {
          // do nothing
        } else {
          if(response && response.componentData && response.componentData.BasePlan && response.componentData.BasePlan.BasePlanComponent){
            response.componentData.BasePlan.BasePlanComponent['proposalCoverageSchedules'] = [];
          
        if (policyTerm && productCd) {
          for (let i = 0; i < policyTerm; i++) {
            let policyCoverageSchedule = new PolicyCoverageScheduleDO();
            policyCoverageSchedule.productTypeCd = productCd;
            policyCoverageSchedule.policyYear = i + 1;

            response.componentData.BasePlan.BasePlanComponent['proposalCoverageSchedules'].push(policyCoverageSchedule);
          }
        }
          basePlan = [response.componentData.BasePlan.BasePlanComponent];
        }
        }
      } else {
        if (response.componentData.BasePlan && response.componentData.BasePlan.BasePlanComponent) {

          response.componentData.BasePlan.BasePlanComponent['planOptionCd'] = payload[DO]['productPlanOptionCd'];
          response.componentData.BasePlan.BasePlanComponent['productCd']=payload[DO]['baseProductCd'];
          
          let policyTerm = response.componentData.BasePlan.BasePlanComponent.policyTerm;
          let productCd = response.componentData.BasePlan.BasePlanComponent.productCd;
          
          response.componentData.BasePlan.BasePlanComponent['proposalCoverageSchedules'] = [];
          if (policyTerm && productCd) {
            for (let i = 0; i < policyTerm; i++) {
              let policyCoverageSchedule = new PolicyCoverageScheduleDO();
              policyCoverageSchedule.productTypeCd = productCd;
              policyCoverageSchedule.policyYear = i + 1;
              response.componentData.BasePlan.BasePlanComponent['proposalCoverageSchedules'].push(policyCoverageSchedule);
            }
          }
          
          let foundBasePlan = payload[DO][CoveragesNode].find(item => item.planTypeCd === 'BASEPLAN')

          // if (foundBasePlan && foundBasePlan['policyCoverageScheduleList'] && policyTerm === foundBasePlan['policyCoverageScheduleList'].length) {
          //   response.componentData.BasePlan.BasePlanComponent['policyCoverageScheduleList'] = foundBasePlan['policyCoverageScheduleList'];
          // } else {
          //   let oldScheduledList = foundBasePlan['policyCoverageScheduleList'].filter(item => item.id)
          //   response.componentData.BasePlan.BasePlanComponent['policyCoverageScheduleList'] = oldScheduledList;
          //   let newproposalterm = policyTerm - oldScheduledList.length;

          //   for (let i = 0; i < newproposalterm; i++) {
          //     let policyCoverageSchedule = new PolicyCoverageScheduleDO();
          //     policyCoverageSchedule.productTypeCd = productCd;
          //     i = oldScheduledList.length;
          //     policyCoverageSchedule.policyYear = i + 1;

          //     response.componentData.BasePlan.BasePlanComponent['policyCoverageScheduleList'].push(policyCoverageSchedule);
          //   }
          // }
          response.componentData.BasePlan.BasePlanComponent['planOptionCd'] = payload[DO]['productPlanOptionCd'];
          response.componentData.BasePlan.BasePlanComponent['planTypeCd']= "BASEPLAN";
          response.componentData.BasePlan.BasePlanComponent['packageCd'] = payload[DO]['packageCd'];
          response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode] = foundBasePlan[CoveragesInsuredNode];
          payload[DO].sumInsuredAmt = response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt'];
          basePlan = [response.componentData.BasePlan.BasePlanComponent];
        }
        else
          basePlan = payload[DO][CoveragesNode].filter(item => item.planTypeCd === 'BASEPLAN')
      }
      // base plan transform end

      //mandatory coverages transform starts
      let mandatoryCoveragesList = [];

      // if (response.componentData.MandatoryCoverages['MandatoryCoveragesComponent'] && this.commonUtilty.isArrayIterable(response.componentData.MandatoryCoverages.MandatoryCoveragesComponent.mandatoryCoveragesArray)) {
      //   let oldMandatoryCoverages = response.componentData.MandatoryCoverages.MandatoryCoveragesComponent.mandatoryCoveragesArray.filter(item => item.id);
      //   let newMandatoryCoverages = response.componentData.MandatoryCoverages.MandatoryCoveragesComponent.mandatoryCoveragesArray.filter(item => !item.id);

      //   oldMandatoryCoverages.forEach(oldCov => {
      //     oldCov[CoveragesInsuredNode] = [];
      //     let coverage = payload[DO][CoveragesNode].find(item => oldCov.productCd === item.productCd)
      //     oldCov[CoveragesInsuredNode] = coverage[CoveragesInsuredNode]
      //   });

      //   newMandatoryCoverages.forEach((mandatoryCov, index) => {

      //     if (this.commonUtilty.isArrayIterable(response.componentData.insuredList)) {
      //       response.componentData.insuredList.forEach(insured => {
      //         let mandatoryCoverage = new PolicyCoverageDO();
      //         mandatoryCoverage = this.commonUtilty.deepCopy(mandatoryCov);

      //         let coverageInsureds = new ProposalCoverageInsuredDO();
      //         coverageInsureds.clientRefGuid = insured.lookupKey;
      //         coverageInsureds.roleCd = "INSURED";
      //         mandatoryCoverage[CoveragesInsuredNode] = [];
      //         mandatoryCoverage[CoveragesInsuredNode].push(coverageInsureds);
      //         mandatoryCoveragesList.push(mandatoryCoverage);
      //       });
      //     }
      //   });
      //   mandatoryCoverages.push(...oldMandatoryCoverages, ...mandatoryCoveragesList);
      // } else {
      //   mandatoryCoverages = payload[DO][CoveragesNode].filter(item => item.planTypeCd === 'RIDER' && item.associationTypeCd == 'MANDATORY')
      // }
      if(response.componentData.BasePlan && response.componentData.BasePlan.BasePlanComponent){
        //if(!this.commonUtilty.isArrayIterable(response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode]))
          response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode] = [];
         if(payload[DO] && this.commonUtilty.isArrayIterable(payload[DO].proposalClients)){
          payload[DO].proposalClients.forEach(insured => {
            let isExist = response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode].find(item => item.clientRefGuid == insured.clientRefGuid);
            if(!isExist && (insured.roleCd != 'NOMINEE' && insured.roleCd != 'OWNER')){
              let coverageInsureds = new ProposalCoverageInsuredDO();
              coverageInsureds.clientRefGuid = insured.clientRefGuid;
              // coverageInsureds.clientId = insured.clientId;
              coverageInsureds.roleCd = insured.roleCd;
              response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode].push(coverageInsureds);
            }
          });
         }
         basePlan = [response.componentData.BasePlan.BasePlanComponent];
      }


      if(this.commonUtilty.isArrayIterable(response.componentData.MandatoryCoverages)){
        response.componentData.MandatoryCoverages.forEach((mandatoryCov, index) => {
          mandatoryCov[CoveragesInsuredNode] = [];
          mandatoryCov['associationTypeCd'] = 'MANDATORY';
          mandatoryCov['planTypeCd'] = 'RIDER';
          mandatoryCov['productCd'] = mandatoryCov.riderCd;
         if(payload[DO] && this.commonUtilty.isArrayIterable(payload[DO].proposalClients)){
          payload[DO].proposalClients.forEach(insured => {
            let isExist = mandatoryCov[CoveragesInsuredNode].find(item => item.clientRefGuid == insured.clientRefGuid);
            if(!isExist && (insured.roleCd != 'NOMINEE' && insured.roleCd != 'OWNER')){
              let coverageInsureds = new ProposalCoverageInsuredDO();
              coverageInsureds.clientRefGuid = insured.clientRefGuid;
              // coverageInsureds.clientId = insured.clientId;
              coverageInsureds.roleCd = insured.roleCd;
              mandatoryCov[CoveragesInsuredNode].push(coverageInsureds);
            }
          });
         } 
        });
        mandatoryCoverages =response.componentData.MandatoryCoverages;
      }

      /*if(this.commonUtilty.isArrayIterable(response.componentData.MandatoryCoverages)){
        response.componentData.MandatoryCoverages.forEach((mandatoryCov, index) => {
          let mandatoryCoverageInsuredList = [];
          let coverageInsureds = new ProposalCoverageInsuredDO();
          coverageInsureds.clientRefGuid = mandatoryCov.clientRefGuid;
          coverageInsureds.roleCd = "INSURED";
          mandatoryCoverageInsuredList.push(coverageInsureds);
         response.componentData.MandatoryCoverages[index][CoveragesInsuredNode] = this.commonUtilty.deepCopy(mandatoryCoverageInsuredList);
        });
        mandatoryCoverages =response.componentData.MandatoryCoverages;
      } else {
        mandatoryCoverages = payload[DO][CoveragesNode].filter(item => item.planTypeCd === 'RIDER' && item.associationTypeCd == 'MANDATORY')
      }*/
      //mandatory coverages transform end

      //additional coverages transform starts
      // if (response.componentData.AdditionalCoverages['AdditionalCoveragesComponent'] && this.commonUtilty.isArrayIterable(response.componentData.AdditionalCoverages.AdditionalCoveragesComponent.additionalCoveragesArray)) {
      //   response.componentData.AdditionalCoverages.AdditionalCoveragesComponent.additionalCoveragesArray.forEach((additionalCov, index) => {
      //     let additionalCoverageInsuredList = [];
      //     let coverageInsureds = new ProposalCoverageInsuredDO();
      //     coverageInsureds.clientRefGuid = additionalCov.clientRefGuid;
      //     coverageInsureds.roleCd = "INSURED";
      //     additionalCoverageInsuredList.push(coverageInsureds);
      //     response.componentData.AdditionalCoverages.AdditionalCoveragesComponent.additionalCoveragesArray[index][CoveragesInsuredNode] = this.commonUtilty.deepCopy(additionalCoverageInsuredList);
      //   });
      //   additionalCoverages = response.componentData.AdditionalCoverages.AdditionalCoveragesComponent.additionalCoveragesArray;
      // } else {
      //   additionalCoverages = payload[DO][CoveragesNode].filter(item => item.planTypeCd === 'RIDER' && item.associationTypeCd == 'OPTIONAL')
      // }
      /*if (this.commonUtilty.isArrayIterable(response.componentData.AdditionalCoverages)) {
        response.componentData.AdditionalCoverages.forEach((additionalCov, index) => {
          let additionalCoverageInsuredList = [];
          let coverageInsureds = new ProposalCoverageInsuredDO();
          coverageInsureds.clientRefGuid = additionalCov.clientRefGuid;
          coverageInsureds.roleCd = "INSURED";
          additionalCoverageInsuredList.push(coverageInsureds);
         response.componentData.AdditionalCoverages[index][CoveragesInsuredNode] = this.commonUtilty.deepCopy(additionalCoverageInsuredList);
        });
        additionalCoverages =response.componentData.AdditionalCoverages;
      } else {
        additionalCoverages = payload[DO][CoveragesNode].filter(item => item.planTypeCd === 'RIDER' && item.associationTypeCd == 'OPTIONAL')
      }*/

      if(this.commonUtilty.isArrayIterable(response.componentData.AdditionalCoverages)){
        response.componentData.AdditionalCoverages.forEach((additionalCov, index) => {
          additionalCov[CoveragesInsuredNode] = [];
          additionalCov['associationTypeCd'] = 'OPTIONAL';
          additionalCov['planTypeCd'] = 'RIDER';
          additionalCov['productCd'] = additionalCov.riderCd;
         if(payload[DO] && this.commonUtilty.isArrayIterable(payload[DO].proposalClients)){
          payload[DO].proposalClients.forEach(insured => {
            let isExist = additionalCov[CoveragesInsuredNode].find(item => item.clientRefGuid == insured.clientRefGuid);
            if(!isExist && (insured.roleCd != 'NOMINEE' && insured.roleCd != 'OWNER')){
              let coverageInsureds = new ProposalCoverageInsuredDO();
              coverageInsureds.clientRefGuid = insured.clientRefGuid;
              // coverageInsureds.clientId = insured.clientId;
              coverageInsureds.roleCd = insured.roleCd;
              additionalCov[CoveragesInsuredNode].push(coverageInsureds);
            }
          });
         } 
        });
        additionalCoverages =response.componentData.AdditionalCoverages;
      }
	  
      //additional coverages transform end

      // if (this.commonUtilty.isArrayIterable(basePlan) && this.commonUtilty.isArrayIterable(mandatoryCoverages) && this.commonUtilty.isArrayIterable(additionalCoverages)) {
      let coverages = [...basePlan, ...mandatoryCoverages, ...additionalCoverages];

      payload[DO][CoveragesNode] = this.commonUtilty.deepCopy(coverages);
      // }
      if (this.commonUtilty.isArrayIterable(payload[DO][CoveragesNode])) {
        payload[DO][CoveragesNode].forEach(coverage => {
          if(payload[DO] && payload[DO].policyCommencementDt && coverage){
            if(!coverage.commencementDt){
              coverage.commencementDt = null;
            }
              coverage.commencementDt = payload[DO].policyCommencementDt;
          }
          if(payload[DO] && payload[DO].policyExpiryDt && coverage){
            if(!coverage.expiryDt){
              coverage.expiryDt = null;
            }
              coverage.expiryDt = payload[DO].policyExpiryDt;
          }
        });
      }
      // if (this.commonUtilty.isArrayIterable(payload[DO]['proposalPremiumBreakups']) || this.commonUtilty.isArrayIterable(payload[DO]['casePremiumBreakups'])) {
      //   //do nothing
      // } else {
      //   let premiumBreakup = new ProposalPremiumBreakupDO();
      //   if (DO != 'caseDO')
      //     payload[DO]['proposalPremiumBreakups'].push(premiumBreakup);
      //   else
      //     payload[DO]['casePremiumBreakups'].push(premiumBreakup);

      // }
      let premiumBreakup = new PolicyPremiumBreakupDO();
      if (DO != 'caseDO')
        payload[DO]['proposalPremiumBreakups'].push(premiumBreakup);
      else {
        payload[DO]['casePremiumBreakups'].push(premiumBreakup);
      }
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  HealthUItoServerTransform(payload, response) {
    let DO = this.commonUtilty.getDOName(payload)
    let CoveragesNode = DO == 'caseDO' ? 'caseCoverages' : 'proposalCoverages';
    let PaymentNode = DO == 'caseDO' ? 'casePayments' : 'proposalPayments';
    let ClientListNode = DO == 'caseDO' ? 'caseClients' : 'proposalClients';
    let CoveragesInsuredNode = DO == 'caseDO' ? 'caseCoverageInsureds' : 'proposalCoverageInsureds';
    let CoveragesScheduleNode = DO == 'caseDO' ? 'caseCoverageSchedules' : 'proposalCoverageSchedules';
    let clientGuid = null;
    let clientId = null;
    let basePlan = [];
    let mandatoryCoverages = [];
    let additionalCoverages = [];
    if (payload && payload[DO]) {
      if(!response.componentData.BasePlan['BasePlanComponent']){
        response.componentData.BasePlan['BasePlanComponent'] = {};
      }
        response.componentData.BasePlan.BasePlanComponent['policyTerm'] = response.componentData.BasePlan.BasePlanComponent['policyTerm'] || payload[DO]['policyTerm'];
        response.componentData.BasePlan.BasePlanComponent['premiumPaymentTerm'] = response.componentData.BasePlan.BasePlanComponent['premiumPaymentTerm'] || payload[DO]['premiumPaymentTerm'];
        response.componentData.BasePlan.BasePlanComponent['productOption'] = response.componentData.BasePlan.BasePlanComponent['productOption'] || payload[DO]['productOption'];
        response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt'] = response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt'] || payload[DO]['sumInsuredAmt'];
        payload[DO]['paymentFrequencyCd'] = response.componentData.BasePlan.BasePlanComponent['paymentFrequencyCd'];
      if(!this.commonUtilty.isArrayIterable(payload[DO][PaymentNode])){
        payload[DO][PaymentNode].push({'paymentFrequencyCd' : null});
      }
      payload[DO][PaymentNode][0]['paymentFrequencyCd'] = response.componentData.BasePlan.BasePlanComponent['paymentFrequencyCd'];
      //payload[DO]['currencyCd'] = response.componentData.BasePlan.BasePlanComponent['currencyCd'];
      payload[DO]['policyTerm'] = response.componentData.BasePlan.BasePlanComponent['policyTerm'];
      payload[DO]['premiumPaymentTerm'] = response.componentData.BasePlan.BasePlanComponent['premiumPaymentTerm'];
      payload[DO]['productOption'] = response.componentData.BasePlan.BasePlanComponent['productOption'];
      payload[DO]['sumInsuredAmt'] = response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt'];
      
      // base plan transform starts
      let policyClient = payload[DO][ClientListNode].find(item => item.roleCd === 'PRIMARYINSURED')
      clientGuid = policyClient ? policyClient.clientRefGuid : null;
      clientId = policyClient ? policyClient.clientId : null;
      let foundIndex = payload[DO][CoveragesNode].findIndex(item => item.planTypeCd === 'BASEPLAN')
      if (foundIndex == -1) {
        let coverageInsured = new ProposalCoverageInsuredDO();
        // coverageInsured.clientId = clientId;
        coverageInsured.clientRefGuid = clientGuid;
        coverageInsured.roleCd = "PRIMARYINSURED";
        let coverageInsuredList = [coverageInsured];
        response.componentData.BasePlan.BasePlanComponent['planOptionCd'] = payload[DO]['productPlanOptionCd'];        
        response.componentData.BasePlan.BasePlanComponent['productTypeCd'] = payload[DO]['productPlanOptionCd'];
        response.componentData.BasePlan.BasePlanComponent['productCd']=payload[DO]['baseProductCd'];
        response.componentData.BasePlan.BasePlanComponent['planTypeCd']= "BASEPLAN";
        response.componentData.BasePlan.BasePlanComponent['packageCd'] = payload[DO]['packageCd'];
        response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode] = this.commonUtilty.deepCopy(coverageInsuredList);
        let policyTerm = response.componentData.BasePlan.BasePlanComponent.policyTerm;
        let productCd = response.componentData.BasePlan.BasePlanComponent.productCd;
        payload[DO].sumInsuredAmt = response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt'];
        let coverageSchedule = payload[DO][CoveragesNode].find(item => item.planTypeCd === 'BASEPLAN')

        if (coverageSchedule && coverageSchedule[CoveragesScheduleNode] && policyTerm === coverageSchedule[CoveragesScheduleNode].length) {
          // do nothing
        } else {
          response.componentData.BasePlan.BasePlanComponent[CoveragesScheduleNode] = [];
          if (policyTerm && productCd) {
            for (let i = 0; i < policyTerm; i++) {
              let policyCoverageSchedule = new PolicyCoverageScheduleDO();
              policyCoverageSchedule.productTypeCd = productCd;
              policyCoverageSchedule.policyYear = i + 1;
              response.componentData.BasePlan.BasePlanComponent[CoveragesScheduleNode].push(policyCoverageSchedule);
            }
          }
          basePlan = [response.componentData.BasePlan.BasePlanComponent];
        }
      } else {
        if (response.componentData.BasePlan && response.componentData.BasePlan.BasePlanComponent) {
          response.componentData.BasePlan.BasePlanComponent['planOptionCd'] = payload[DO]['productPlanOptionCd'];
          response.componentData.BasePlan.BasePlanComponent['productCd']=payload[DO]['baseProductCd'];
          //response.componentData.BasePlan.BasePlanComponent['productTypeCd'] = payload[DO]['productPlanOptionCd'];
          let policyTerm = response.componentData.BasePlan.BasePlanComponent.policyTerm;
          let productCd = response.componentData.BasePlan.BasePlanComponent.planOptionCd;

          response.componentData.BasePlan.BasePlanComponent[CoveragesScheduleNode] = [];
          if (policyTerm && productCd) {
            for (let i = 0; i < policyTerm; i++) {
              let policyCoverageSchedule = new PolicyCoverageScheduleDO();
              policyCoverageSchedule.productTypeCd = productCd;
              policyCoverageSchedule.policyYear = i + 1;
              response.componentData.BasePlan.BasePlanComponent[CoveragesScheduleNode].push(policyCoverageSchedule);
            }
          }
          let foundBasePlan = payload[DO][CoveragesNode].find(item => item.planTypeCd === 'BASEPLAN')

          // if (foundBasePlan && foundBasePlan['policyCoverageScheduleList'] && Number(policyTerm) === foundBasePlan['policyCoverageScheduleList'].length) {
          //   response.componentData.BasePlan.BasePlanComponent['policyCoverageScheduleList'] = foundBasePlan['policyCoverageScheduleList'];
          // } else {
          //   let oldScheduledList = foundBasePlan['policyCoverageScheduleList'].filter(item => item.id)
          //   response.componentData.BasePlan.BasePlanComponent['policyCoverageScheduleList'] = oldScheduledList;
          //   let newproposalterm = policyTerm - oldScheduledList.length;

          //   for (let i = 0; i < newproposalterm; i++) {
          //     let policyCoverageSchedule = new PolicyCoverageScheduleDO();
          //     policyCoverageSchedule.productTypeCd = productCd;
          //     i = oldScheduledList.length;
          //     policyCoverageSchedule.policyYear = i + 1;

          //     response.componentData.BasePlan.BasePlanComponent['policyCoverageScheduleList'].push(policyCoverageSchedule);
          //   }
          // }
          response.componentData.BasePlan.BasePlanComponent['planOptionCd'] = payload[DO]['productPlanOptionCd'];
          response.componentData.BasePlan.BasePlanComponent['planTypeCd']= "BASEPLAN";
          response.componentData.BasePlan.BasePlanComponent['packageCd'] = payload[DO]['packageCd'];
          response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode] = foundBasePlan[CoveragesInsuredNode];
          payload[DO].sumInsuredAmt = response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt'];
          basePlan = [response.componentData.BasePlan.BasePlanComponent];
        }
        else
          basePlan = payload[DO][CoveragesNode].filter(item => item.planTypeCd === 'BASEPLAN')
      }
      // base plan transform end

      //mandatory coverages transform starts
      let mandatoryCoveragesList = [];

      // if (response.componentData.MandatoryCoverages['MandatoryCoveragesComponent'] && this.commonUtilty.isArrayIterable(response.componentData.MandatoryCoverages.MandatoryCoveragesComponent.mandatoryCoveragesArray)) {
      //   let oldMandatoryCoverages = response.componentData.MandatoryCoverages.MandatoryCoveragesComponent.mandatoryCoveragesArray.filter(item => item.id);
      //   let newMandatoryCoverages = response.componentData.MandatoryCoverages.MandatoryCoveragesComponent.mandatoryCoveragesArray.filter(item => !item.id);

      //   oldMandatoryCoverages.forEach(oldCov => {
      //     oldCov[CoveragesInsuredNode] = [];
      //     let coverage = payload[DO][CoveragesNode].find(item => oldCov.productCd === item.productCd)
      //     oldCov[CoveragesInsuredNode] = coverage[CoveragesInsuredNode]
      //   });

      //   newMandatoryCoverages.forEach((mandatoryCov, index) => {
      //     let mandatoryCoverage = new PolicyCoverageDO();
      //     mandatoryCoverage = this.commonUtilty.deepCopy(mandatoryCov);
      //     mandatoryCoverage[CoveragesInsuredNode] = [];
      //     if (this.commonUtilty.isArrayIterable(response.componentData.insuredList)) {
      //       response.componentData.insuredList.forEach(insured => {
      //         let coverageInsureds = new ProposalCoverageInsuredDO();
      //         coverageInsureds.clientRefGuid = insured.lookupKey;
      //         coverageInsureds.roleCd = "INSURED";
      //         mandatoryCoverage[CoveragesInsuredNode].push(coverageInsureds);
      //       });
      //     }
      //     mandatoryCoveragesList.push(mandatoryCoverage);
      //   });
      //   mandatoryCoverages.push(...oldMandatoryCoverages, ...mandatoryCoveragesList);
      // } else {
      //   mandatoryCoverages = payload[DO][CoveragesNode].filter(item => item.planTypeCd === 'RIDER' && item.associationTypeCd == 'MANDATORY')
      // }

      if(response.componentData.BasePlan && response.componentData.BasePlan.BasePlanComponent){
        //if(!this.commonUtilty.isArrayIterable(response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode]))
          response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode] = [];
         if(payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][ClientListNode])){
          payload[DO][ClientListNode].forEach(insured => {
            let isExist = response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode].find(item => item.clientRefGuid == insured.clientRefGuid);
            if(!isExist && (insured.roleCd != 'NOMINEE' && insured.roleCd != 'OWNER')){
              let coverageInsureds = new ProposalCoverageInsuredDO();
              coverageInsureds.clientRefGuid = insured.clientRefGuid;
              // coverageInsureds.clientId = insured.clientId;
              coverageInsureds.roleCd = insured.roleCd;
              response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode].push(coverageInsureds);
            }
          });
         }
         if(payload && payload[DO] && payload[DO][CoveragesNode] && payload[DO][CoveragesNode][0]){
           let basePlanCoverageData = payload[DO][CoveragesNode][0]
           basePlanCoverageData['baseAnnualPremium'] = payload[DO]['baseAnnualPremium'] || basePlanCoverageData['baseAnnualPremium']  
           basePlanCoverageData['sumInsuredAmt'] = payload[DO]['sumInsuredAmt'] || basePlanCoverageData['sumInsuredAmt']
           basePlan = [basePlanCoverageData];
        }
        else basePlan = [response.componentData.BasePlan.BasePlanComponent]
      }

      // if(this.commonUtilty.isArrayIterable(response.componentData.MandatoryCoverages)){
      //   response.componentData.MandatoryCoverages.forEach((mandatoryCov, index) => {
      //     let mandatoryCoverageInsuredList = [];
      //     let coverageInsureds = new ProposalCoverageInsuredDO();
      //     coverageInsureds.clientRefGuid = mandatoryCov.clientRefGuid;
      //     coverageInsureds.roleCd = "INSURED";
      //     mandatoryCov['associationTypeCd'] = 'MANDATORY';
      //     mandatoryCov['planTypeCd'] = 'RIDER';
      //     mandatoryCov['productCd'] = mandatoryCov.riderCd;

      //     mandatoryCoverageInsuredList.push(coverageInsureds);
      //    response.componentData.MandatoryCoverages[index][CoveragesInsuredNode] = this.commonUtilty.deepCopy(mandatoryCoverageInsuredList);
      //   });
      //   mandatoryCoverages =response.componentData.MandatoryCoverages;
      // } else {
      //   mandatoryCoverages = payload[DO][CoveragesNode].filter(item => item.planTypeCd === 'RIDER' && item.associationTypeCd == 'MANDATORY')
      // }

      if(this.commonUtilty.isArrayIterable(response.componentData.MandatoryCoverages)){
        response.componentData.MandatoryCoverages.forEach((mandatoryCov, index) => {
          mandatoryCov[CoveragesInsuredNode] = [];
          mandatoryCov['associationTypeCd'] = 'MANDATORY';
          mandatoryCov['planTypeCd'] = 'RIDER';
          mandatoryCov['productCd'] = mandatoryCov.riderCd;
         if(payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][ClientListNode])){
          payload[DO][ClientListNode].forEach(insured => {
            let isExist = mandatoryCov[CoveragesInsuredNode].find(item => item.clientRefGuid == insured.clientRefGuid);
            if(!isExist && (insured.roleCd != 'NOMINEE' && insured.roleCd != 'OWNER')){
              let coverageInsureds = new ProposalCoverageInsuredDO();
              coverageInsureds.clientRefGuid = insured.clientRefGuid;
              // coverageInsureds.clientId = insured.clientId;
              coverageInsureds.roleCd = insured.roleCd;
              mandatoryCov[CoveragesInsuredNode].push(coverageInsureds);
            }
          });
         } 
        });
        mandatoryCoverages =response.componentData.MandatoryCoverages;
      }

      //mandatory coverages transform end

      //additional coverages transform starts
      // one to many mapping logic
      // if (response.componentData.AdditionalCoverages['AdditionalCoveragesComponent'] && this.commonUtilty.isArrayIterable(response.componentData.AdditionalCoverages.AdditionalCoveragesComponent.additionalCoveragesArray)) {
      //   response.componentData.AdditionalCoverages.AdditionalCoveragesComponent.additionalCoveragesArray.forEach((additionalCov, index) => {
      //     let filteredCoverageIndex = additionalCoverages.findIndex(item => item.productCd === additionalCov.productCd)
      //     if (filteredCoverageIndex == -1) {
      //       let additionalCoverage = new PolicyCoverageDO();
      //       let coverageInsureds = new ProposalCoverageInsuredDO();
      //       additionalCoverage = this.commonUtilty.deepCopy(additionalCov);
      //       coverageInsureds.clientRefGuid = additionalCov.clientRefGuid;
      //       coverageInsureds.roleCd = "INSURED";
      //       additionalCoverage[CoveragesInsuredNode] = [];
      //       additionalCoverage[CoveragesInsuredNode].push(coverageInsureds);
      //       additionalCoverages.push(additionalCoverage);
      //     } else {
      //       if (this.commonUtilty.isArrayIterable(additionalCoverages)) {
      //         additionalCoverages.forEach(cov => {
      //           if (additionalCov.productCd === cov.productCd) {
      //             let coverageInsured = new ProposalCoverageInsuredDO();
      //             coverageInsured.clientRefGuid = additionalCov.clientRefGuid;
      //             coverageInsured.roleCd = "INSURED";
      //             cov[CoveragesInsuredNode].push(coverageInsured);
      //           }
      //         })
      //       }
      //     }
      //   });
      // } else {
      //   additionalCoverages = payload[DO][CoveragesNode].filter(item => item.planTypeCd === 'RIDER' && item.associationTypeCd == 'OPTIONAL')
      // }

      // one to one mapping logic
      // if (response.componentData.AdditionalCoverages['AdditionalCoveragesComponent'] && this.commonUtilty.isArrayIterable(response.componentData.AdditionalCoverages.AdditionalCoveragesComponent.additionalCoveragesArray)) {
      //   response.componentData.AdditionalCoverages.AdditionalCoveragesComponent.additionalCoveragesArray.forEach((additionalCov, index) => {
      //     let additionalCoverageInsuredList = [];
      //     let coverageInsureds = new ProposalCoverageInsuredDO();
      //     coverageInsureds.clientRefGuid = additionalCov.clientRefGuid;
      //     coverageInsureds.roleCd = "INSURED";
      //     additionalCoverageInsuredList.push(coverageInsureds);
      //     response.componentData.AdditionalCoverages.AdditionalCoveragesComponent.additionalCoveragesArray[index][CoveragesInsuredNode] = this.commonUtilty.deepCopy(additionalCoverageInsuredList);
      //   });
      //   additionalCoverages = response.componentData.AdditionalCoverages.AdditionalCoveragesComponent.additionalCoveragesArray;
      // } else {
      //   additionalCoverages = payload[DO][CoveragesNode].filter(item => item.planTypeCd === 'RIDER' && item.associationTypeCd == 'OPTIONAL')
      // }

      // if (this.commonUtilty.isArrayIterable(response.componentData.AdditionalCoverages)) {
      //   response.componentData.AdditionalCoverages.forEach((additionalCov, index) => {
      //     let additionalCoverageInsuredList = [];
      //     let coverageInsureds = new ProposalCoverageInsuredDO();
      //     coverageInsureds.clientRefGuid = additionalCov.clientRefGuid;
      //     coverageInsureds.roleCd = "INSURED";          
      //     additionalCov['associationTypeCd'] = 'OPTIONAL';
      //     additionalCov['planTypeCd'] = 'RIDER';
      //     additionalCov['productCd'] = additionalCov.riderCd;
      //     additionalCoverageInsuredList.push(coverageInsureds);
      //    response.componentData.AdditionalCoverages[index][CoveragesInsuredNode] = this.commonUtilty.deepCopy(additionalCoverageInsuredList);
      //   });
      //   additionalCoverages =response.componentData.AdditionalCoverages;
      // } else {
      //   additionalCoverages = payload[DO][CoveragesNode].filter(item => item.planTypeCd === 'RIDER' && item.associationTypeCd == 'OPTIONAL')
      // }
      if(this.commonUtilty.isArrayIterable(response.componentData.AdditionalCoverages)){
        response.componentData.AdditionalCoverages.forEach((additionalCov, index) => {
          additionalCov[CoveragesInsuredNode] = [];
          additionalCov['associationTypeCd'] = 'OPTIONAL';
          additionalCov['planTypeCd'] = 'RIDER';
          additionalCov['productCd'] = additionalCov.riderCd;
         if(payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][ClientListNode])){
          payload[DO][ClientListNode].forEach(insured => {
            let isExist = additionalCov[CoveragesInsuredNode].find(item => item.clientRefGuid == insured.clientRefGuid);
            if(!isExist && (insured.roleCd != 'NOMINEE' && insured.roleCd != 'OWNER')){
              let coverageInsureds = new ProposalCoverageInsuredDO();
              coverageInsureds.clientRefGuid = insured.clientRefGuid;
              // coverageInsureds.clientId = insured.clientId;
              coverageInsureds.roleCd = insured.roleCd;
              additionalCov[CoveragesInsuredNode].push(coverageInsureds);
            }
          });
         } 
        });
        additionalCoverages =response.componentData.AdditionalCoverages;
      }
      //additional coverages transform end

      // if (this.commonUtilty.isArrayIterable(basePlan) && this.commonUtilty.isArrayIterable(mandatoryCoverages) && this.commonUtilty.isArrayIterable(additionalCoverages)) {
      let coverages = [...basePlan, ...mandatoryCoverages, ...additionalCoverages];

      payload[DO][CoveragesNode] = this.commonUtilty.deepCopy(coverages);
      // }
      if (this.commonUtilty.isArrayIterable(payload[DO][CoveragesNode])) {
        payload[DO][CoveragesNode].forEach(coverage => {
          if(payload[DO] && payload[DO].policyCommencementDt  && coverage){
            if(!coverage.commencementDt){
              coverage.commencementDt = null;
            }
              coverage.commencementDt = payload[DO].policyCommencementDt;
          }
          if(payload[DO] && payload[DO].policyExpiryDt  && coverage){
            if(!coverage.expiryDt){
              coverage.expiryDt = null;
            }
              coverage.expiryDt = payload[DO].policyExpiryDt;
          }
        });
      }
      let premiumBreakup = new PolicyPremiumBreakupDO();
      if (DO != 'caseDO')
        payload[DO]['proposalPremiumBreakups'].push(premiumBreakup);
      else {
        payload[DO]['casePremiumBreakups'].push(premiumBreakup);
      }
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  mapAllCoveragesToPayload(coverageObjList ,payloadCoverageList){
    let finalPayloadCoverageList = []
    if(coverageObjList && this.commonUtilty.isArrayIterable(coverageObjList) && coverageObjList.length){
      coverageObjList.forEach((coverage,i) => {
        console.log(coverage, payloadCoverageList)
        let existingCov = payloadCoverageList.filter(cov =>(cov.productCd || cov.riderCd) == coverage.riderCd)

        // if(!payloadCoverageList[i]){
        //   payloadCoverageList[i] = {
        //       "sumInsuredAmt": 0,
        //       "baseAnnualPremium": null,
        //       "riderCd": coverage.riderCd
        //   }
        // }
        if(existingCov && existingCov.length){
          existingCov[0]['riderCd'] = coverage.riderCd
          finalPayloadCoverageList = this.commonUtilty.uniquePushInArray(finalPayloadCoverageList, existingCov[0] , 'riderCd')
        }
        else {
          let cover = {
            "sumInsuredAmt": 0,
            "baseAnnualPremium": null,
            "riderCd": coverage.riderCd
          }
          finalPayloadCoverageList = this.commonUtilty.uniquePushInArray(finalPayloadCoverageList, cover , 'riderCd')
        }
      })
    }
    return finalPayloadCoverageList;
  }

  convertCoverageValueToString(payload , DO){
    let coverageList = DO == 'caseDO' ? 'caseCoverages' : 'proposalCoverages'; 
    if(payload && payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][coverageList])){
      payload[DO][coverageList].forEach(element => {
        element['sumInsuredAmt'] = element['sumInsuredAmt'] ? element['sumInsuredAmt'].toString() : element['sumInsuredAmt'];
      });
    }
    return payload;
  }

  LifeServerToUITransform(payload) {
    let DO = this.commonUtilty.getDOName(payload);
    this.payloadForMandatoryCoverages = this.commonUtilty.deepCopy(payload);
    this.payloadForAdditionalCoverages = this.commonUtilty.deepCopy(payload);
    let CoveragesNode = this.configData.CoverageNodeMapper[this.transactionState];
    payload[DO]['policyTerm'] = payload[DO]['policyTerm'] ? payload[DO]['policyTerm'].toString() : '';
    payload[DO]['policyTerm'] = payload[DO]['policyTerm'];
    payload[DO]['sumInsuredAmt'] = payload[DO]['sumInsuredAmt'] ? payload[DO]['sumInsuredAmt'].toString() : '';
    
    let CoveragesInsuredNode = this.configData.CoverageInsuredNodeMapper[this.transactionState];
    //this.payloadForMandatoryCoverages[DO][CoveragesNode] = this.lifeCoveragesServertoUITransformHandler(this.payloadForMandatoryCoverages, DO, CoveragesNode, CoveragesInsuredNode, 'MANDATORY')
    //this.payloadForAdditionalCoverages[DO][CoveragesNode] = this.lifeCoveragesServertoUITransformHandler(this.payloadForAdditionalCoverages, DO, CoveragesNode, CoveragesInsuredNode, 'OPTIONAL')
    this.mandatoryCoverageComponentData = this.lifeCoveragesServertoUITransformHandler(this.payloadForMandatoryCoverages, DO, CoveragesNode, CoveragesInsuredNode, 'MANDATORY')
    this.additionalCoveragesComponentData = this.lifeCoveragesServertoUITransformHandler(this.payloadForAdditionalCoverages, DO, CoveragesNode, CoveragesInsuredNode, 'OPTIONAL')
    payload = this.convertCoverageValueToString(payload, DO);
    return payload;
  }

  HealthServerToUITransform(payload) {
    let DO = this.commonUtilty.getDOName(payload);
    this.payloadForMandatoryCoverages = this.commonUtilty.deepCopy(payload);
    this.payloadForAdditionalCoverages = this.commonUtilty.deepCopy(payload);
    let CoveragesNode = this.configData.CoverageNodeMapper[this.transactionState];
    payload[DO]['policyTerm'] = payload[DO]['policyTerm'] ? payload[DO]['policyTerm'].toString() : '';
    payload[DO]['policyTerm'] = payload[DO]['policyTerm'];
    payload[DO]['sumInsuredAmt'] = payload[DO]['sumInsuredAmt'] ? payload[DO]['sumInsuredAmt'].toString() : '';
    //payload[DO][CoveragesNode][0]['sumInsuredAmt'] = payload[DO][CoveragesNode][0]['sumInsuredAmt'] ? payload[DO][CoveragesNode][0]['sumInsuredAmt'].toString() : '';

    let CoveragesInsuredNode = this.configData.CoverageInsuredNodeMapper[this.transactionState];
    this.mandatoryCoverageComponentData = this.HealthCoveragesServertoUITransformHandler(this.payloadForMandatoryCoverages, DO, CoveragesNode, CoveragesInsuredNode, 'MANDATORY')
    this.additionalCoveragesComponentData = this.HealthCoveragesServertoUITransformHandler(this.payloadForAdditionalCoverages, DO, CoveragesNode, CoveragesInsuredNode, 'OPTIONAL')
    payload = this.convertCoverageValueToString(payload, DO);
    return payload;
  }

  lifeCoveragesServertoUITransformHandler(payload, DO, CoveragesNode, CoveragesInsuredNode, transformFor) {
    let list = [];
    if (payload && payload[DO]) {
      if (this.commonUtilty.isArrayIterable(payload[DO][CoveragesNode])) {
        payload[DO][CoveragesNode].forEach((coverage, index) => {
          if (coverage.planTypeCd != 'BASEPLAN' && coverage.associationTypeCd == transformFor) {
            if (transformFor == 'OPTIONAL') {
              let coverageInsured = coverage[CoveragesInsuredNode].find(item => true)
              if(coverageInsured)
              coverage['clientRefGuid'] = coverageInsured.clientRefGuid;
              // list.push(coverage);
            }
            if (coverage.associationTypeCd == 'MANDATORY') {
              // if (this.commonUtilty.isArrayIterable(list)) {
              let foundIndex = list.findIndex(item => item.productCd == coverage.productCd)
              if (foundIndex == -1)
                list.push(coverage);
              // }
            } else
              list.push(coverage);
          }
        })
      }
    }
    if (transformFor == 'MANDATORY') {
      let mclist = list.filter(item => item.associationTypeCd === 'MANDATORY')
      if (this.commonUtilty.isArrayIterable(mclist)) { }
      else {
        if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd'])) {
          this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd'].forEach(lookup => {
            let mc = new PolicyCoverageDO();
            mc.productCd = lookup.lookupKey;
            mc.planTypeCd = 'RIDER';
            mc.associationType = 'MANDATORY';
            list.push(mc);
          });
        }
      }
    }
    return list;
  }

  HealthCoveragesServertoUITransformHandler(payload, DO, CoveragesNode, CoveragesInsuredNode, transformFor) {
    let list = [];
    if (payload && payload[DO]) {
      if (this.commonUtilty.isArrayIterable(payload[DO][CoveragesNode])) {
        payload[DO][CoveragesNode].forEach((coverage, index) => {
          if (coverage.planTypeCd != 'BASEPLAN' && coverage.associationTypeCd == transformFor) {
            // one to many mapping logic
            // if (transformFor == 'OPTIONAL') {
            //   if (this.commonUtilty.isArrayIterable(coverage[CoveragesInsuredNode]) && coverage[CoveragesInsuredNode].length > 1) {
            //     let transformedOptionalCoverages = [];
            //     coverage[CoveragesInsuredNode].forEach(covIns => {
            //       let transformedCoverage = new PolicyCoverageDO();
            //       transformedCoverage = this.commonUtilty.deepCopy(coverage);
            //       transformedCoverage['clientRefGuid'] = covIns.clientRefGuid;
            //       transformedCoverage.policyCoverageInsuredList.push(covIns);
            //       transformedOptionalCoverages.push(transformedCoverage);
            //     });
            //     list = [...transformedOptionalCoverages];
            //   } else {
            //     let coverageInsured = coverage[CoveragesInsuredNode].find(item => true)
            //     coverage['clientRefGuid'] = coverageInsured.clientRefGuid;
            //     list.push(coverage);
            //   }
            // }

            // one to one mapping logic
            if (transformFor == 'OPTIONAL') {
              let coverageInsured = coverage[CoveragesInsuredNode].find(item => true)
              if(coverageInsured)
              coverage['clientRefGuid'] = coverageInsured.clientRefGuid;
              coverage.sumInsuredAmt = coverage.sumInsuredAmt ? coverage.sumInsuredAmt.toString(): coverage.sumInsuredAmt;
              list.push(coverage);
            }
            if (coverage.associationTypeCd == 'MANDATORY') {
              coverage.sumInsuredAmt = coverage.sumInsuredAmt ? coverage.sumInsuredAmt.toString(): coverage.sumInsuredAmt;
              list.push(coverage);
            }
          }
        })
      }
    }

    if (transformFor == 'MANDATORY') {
      let mclist = list.filter(item => item.associationTypeCd === 'MANDATORY')
      if (this.commonUtilty.isArrayIterable(mclist)) { }
      else {
        if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd'])) {
          this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd'].forEach(lookup => {
            let mc = new PolicyCoverageDO();
            mc.productCd = lookup.lookupKey;
            mc.planTypeCd = 'RIDER';
            mc.associationType = 'MANDATORY';
            list.push(mc);
          });
        }
      }
    }
    return list;
  }

  //toggleInsuredListSubject$
  //toggleCoveragesSubject$
  toggleBasePlanSubject$
  refreshCoverageSubject$;

  /*_toggleRefreshAdditionalCoveragesComponent() {
    this.refreshAdditionalCoveragesToggle = false;
    setTimeout(() => {
      this.refreshAdditionalCoveragesToggle = true;
      if (!this._inputDataForEdit)
        this.pushMandatoryCoveragesInPayload()
    }, 300);
  }*/

  _toggleRefreshBasePlanComponent() {
    this.refreshBasePlanToggle = false;
    setTimeout(() => { this.refreshBasePlanToggle = true; }, 300);
  }

  refreshCoverageToggle = true;
  _toggleRefreshCoverageComponent() {
    this.refreshCoverageToggle = false;
    setTimeout(() => { this.refreshCoverageToggle = true; }, 300);
  }

  // displayBenefitData:boolean = false;
  // showProductBenefits(){
  //   this.displayBenefitData = true;
  // }

  saveSelectedBenefits(){

  }

  expandBenefit(event: NzFormatEmitEvent): void{
    console.log(event);
  }

  checkBenefit(event: NzFormatEmitEvent): void{
    console.log(event);
  }

  chooseBenefit(event: NzFormatEmitEvent): void {
    console.log(event);
    this.selectedCoverageFromTree = event.keys ? event.keys[0] : "";
  }

  chosenBenefitsList = [];
  expandChosenBenefitsList = [];
  selectedCoverageListForTree = [];
  selectedCoverageFromTree: string;
  generateUIcoverageBenefitTree(){
    // let DO = this.commonUtilty.getDO(this._inputDataForEdit) || {};
    if(this.product && this.product.productId){
    let selectedProductData = this.productData.filter(item => item.productId === this.product.productId).find(e=> true);
    if(selectedProductData && this.commonUtilty.isArrayIterable(selectedProductData['productRiderAssociationList'])){
      selectedProductData['productRiderAssociationList'].forEach(coverage => {
        if(coverage.associationTypeCd == "MANDATORY"){
          let nodeObj = {
            title : coverage.riderDesc,
            key : coverage.riderCd,
            disableCheckbox : true, 
            children : this.createTreeData(coverage.productRiderBenefitList,'MANDATORY', true)
          }
          this.nodes.push(nodeObj);
          this.chosenBenefitsList.push(coverage.riderCd);
          this.expandChosenBenefitsList.push(coverage.riderCd);
          if(!this.commonUtilty.isArrayIterable(this.selectedCoverageListForTree)){
            this.selectedCoverageListForTree.push(coverage.riderCd);
            this.selectedCoverageFromTree = coverage.riderCd ? coverage.riderCd : "";
          }
        }else if(coverage.associationTypeCd == "OPTIONAL"){
          let nodeObj = {
            title : coverage.riderDesc,
            key : coverage.riderCd,
            children : this.createTreeData(coverage.productRiderBenefitList, 'OPTIONAL')
          }
          this.nodes.push(nodeObj);
        }
      });
    }
  }
    
  }

  createTreeData(benefitList,isMandatory, isDisabled?){
    let tempList = []
    if(this.commonUtilty.isArrayIterable(benefitList)){
      benefitList.forEach(benefit => {
          let nodeObj = {
            title : benefit.benefitName || benefit.benefitId,
            key : benefit.benefitId,
            isLeaf : true,
            disabled: isDisabled
            //children : this.createTreeData(benefit.benefitList)
          }
          tempList.push(nodeObj);
          if(isMandatory == 'MANDATORY'){
            this.chosenBenefitsList.push(nodeObj.key);
          }
      });
    }
    return tempList;
  }

  benefitDataList = [];

  generateUIcoverageBenefitForPanel(){
    if(this.product && this.product.productId){
      let selectedProductData = this.productData.filter(item => item.productId === this.product.productId).find(e=> true);
      if(selectedProductData && this.commonUtilty.isArrayIterable(selectedProductData['productRiderAssociationList'])){
        selectedProductData['productRiderAssociationList'].forEach(coverage => {
          if(coverage.associationTypeCd == "MANDATORY"){
            if(this.commonUtilty.isArrayIterable(this.mandatoryCoverageObjList)){
              let index = this.mandatoryCoverageObjList.indexOf((element) => element.riderCd == coverage.riderCd);
              this.mandatoryCoverageObjList.forEach((element, i) => {
                if(element.riderCd == coverage.riderCd){
                  index = i;
                }
              });
              if(this.mandatoryCoverageObjList[index]){
                this.mandatoryCoverageObjList[index]['productRiderBenefitList'] = coverage.productRiderBenefitList;
              }
            }            
          }else if(coverage.associationTypeCd == "OPTIONAL"){
            if(this.commonUtilty.isArrayIterable(this.additionalCoverageObjList)){
              let index = this.additionalCoverageObjList.indexOf((element) => element.riderCd == coverage.riderCd);
              this.additionalCoverageObjList.forEach((element, i) => {
                if(element.riderCd == coverage.riderCd){
                  index = i;
                }
              });
              if(this.additionalCoverageObjList[index]){
                this.additionalCoverageObjList[index]['productRiderBenefitList'] = coverage.productRiderBenefitList;
              }
            }
          }
        });
      }
    }
  }

  nodes = [];
  // nodes = [
  //   {
  //     title: 'DCC',
  //     key: 'DCC',
  //     expanded: true,
  //     children: [
  //       {
  //         title: 'DCC for Typhus',
  //         key: 'DCC for Typhus',
  //         children: [
  //           { title: 'Daily Cash Compensation', key: 'Daily Cash Compensation', isLeaf: true },
  //           { title: 'Surgeons Fee', key: 'Surgeons Fee', isLeaf: true },
  //         ]
  //       },
  //       {
  //         title: 'DCC for Malaria',
  //         key: 'DCC for Malaria',
  //         children: [
  //           { title: 'Death Compensation', key: 'Death Compensation', isLeaf: true },
  //           { title: 'Medical Aid', key: 'Medical Aid', isLeaf: true }
  //         ]
  //       },
  //       {
  //         title: 'DCC for Dengue',
  //         key: 'DCC for Dengue',
  //         isLeaf: true
  //       }
  //     ]
  //   },
  //   {
  //     title: 'Outpatient Surgery',
  //     key: 'Outpatient Surgery',
  //     children: [
  //       { title: 'Pre and Post Natal Complications', key: 'Pre and Post Natal Complications', isLeaf: true }
  //     ]
  //   }
  // ];

  coverageView = 'panelView';
  isExpand: boolean = true;
  expandCollapsePanel(event){
    this.isExpand = event
  }

  setRider(rider, index){
    if(rider && this.commonUtilty.isArrayIterable(this.additionalCoveragesComponentData) && this.additionalCoveragesComponentData[index]
       && !this.additionalCoveragesComponentData[index]['riderCd']){
      this.additionalCoveragesComponentData[index]['riderCd'] = rider;
    }
  }


}



